import Cookies from 'js-cookie';

document.addEventListener("DOMContentLoaded", async function() {

    //grab the branch_id from the URL (if it exists)
    let branch_id = (window.location.search.indexOf('branch_id=') > -1 ? window.location.search.split('branch_id=')[1].split('&')[0] : false);

    //if we have a branch_id
    if(branch_id) {

        //fetch the branch name
        let branch_name = await get_branch_name(branch_id);

        //if we have a branch name
        if(branch_name) {

            //set a cookie with the branch_id
            Cookies.set('bt_preferred_branch', branch_name, { expires: 1 });
        }

    }
});

function get_branch_name(id) {

    //return a promise
    return new Promise((resolve, reject) => {

        //create a new AJAX request
        var xhttp = new XMLHttpRequest();

        //when the request is complete
        xhttp.onreadystatechange = function() {

            //if the request was successful
            if (this.readyState === 4) {

                //if the request was successful
                if (this.status === 200) {

                    //if we have no response text or it's blank
                    if(!this.responseText || this.responseText == '') {

                        //reject the promise
                        reject('No response text');
                        return;
                    }

                    //resolve the promise with the parsed JSON response
                    resolve(JSON.parse(this.responseText));
                } else { //if the request failed

                    //reject the promise
                    reject('Request failed with status ' + this.status);
                }
            }
        };

        //open the request
        xhttp.open("GET", '/wp-json/laserred/branch-name?id=' + id, true);

        //send the request
        xhttp.send();
    });
}